































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import Space from '@/component/space.vue';
// import region from '../../../public/region.json';
const _ = {
  keyBy: require('lodash/keyBy'),
  each: require('lodash/each'),
};
const { VUE_APP_FCAPI: FCAPI, VUE_APP_STAGE_PREFIX: PREFIX } = process.env;
const getUrl = require('baimahu/url-with-param');
const dateFormat = require('bmh/date-format');
const UPLOAD_DIR = {
  order_img: 'order_img',
  contract: 'contract',
};
const DECORATION_STAGE = [
  {
    value: 1,
    label: '毛坯未开工',
  },
  {
    value: 2,
    label: '毛坯硬装中',
  },
  {
    value: 3,
    label: '毛坯硬装结束',
  },
  {
    value: 4,
    label: '精装未交付',
  },
  {
    value: 5,
    label: '精装已交付',
  },
];
const HOUSE_TYPE = [
  { value: 1, name: '一室' },
  { value: 2, name: '二室' },
  { value: 3, name: '三室' },
  { value: 4, name: '四室' },
  { value: 5, name: '复式' },
  { value: 6, name: '大宅' },
];
const RUAN_STATUS = [
  {
    value: 1,
    label: '注册',
  },
  {
    value: 2,
    label: '报名',
  },
  {
    value: 3,
    label: '待定',
  },
  {
    value: 4,
    label: '到店',
  },
  {
    value: 5,
    label: '下订',
  },
  {
    value: 6,
    label: '签约',
  },
  {
    value: 7,
    label: '无效',
  },
  {
    value: 8,
    label: '退单',
  },
];
const STYLE = [
  {
    label: '北欧',
    value: 1,
  },
  {
    label: '现代',
    value: 2,
  },
  {
    label: '美式',
    value: 3,
  },
  {
    label: '轻奢',
    value: 4,
  },
  {
    label: '新中式',
    value: 5,
  },
  {
    label: '意式',
    value: 6,
  },
  {
    label: '法式',
    value: 7,
  },
  {
    label: '简欧',
    value: 8,
  },
  {
    label: '新古典',
    value: 9,
  },
  {
    label: '日式',
    value: 10,
  },
  {
    label: '港式',
    value: 11,
  },
  {
    label: '其他',
    value: 12,
  },
];
const UNDETERMINED_CAUSE = [
  {
    value: 1,
    label: '未接/拒接',
  },
  {
    value: 2,
    label: '停机/关机',
  },
  {
    value: 3,
    label: '不需要',
  },
  {
    value: 4,
    label: '不着急',
  },
  {
    value: 5,
    label: '有效',
  },
  {
    value: 6,
    label: '明确到店时间',
  },
];
const INVALID_CAUSE = [
  {
    value: 1,
    label: '号码错误',
  },
  {
    value: 2,
    label: '地区不符',
  },
  {
    value: 3,
    label: '已买好',
  },
  {
    value: 4,
    label: '产品/价格不符',
  },
  {
    value: 5,
    label: '不装修',
  },
  {
    value: 6,
    label: '多次联系不上',
  },
  {
    value: 7,
    label: '其他',
  },
];
const REFUND_CAUSE = [
  {
    label: '已选竞品',
    value: 1,
  },
  {
    label: '产品/价格原因',
    value: 2,
  },
  {
    label: '方案不满意',
    value: 3,
  },
  {
    label: '周期原因',
    value: 4,
  },
  {
    label: '其他',
    value: 5,
  },
];
const API = {
  get_user_detail: `${FCAPI}/shang/ruan/user/profile/`, // 用户信息
  decoration_info: `${FCAPI}/shang/ruan/user/house`, // 装修信息
  delete_decoration_info: `${FCAPI}/shang/ruan/user/house/`, // 删除装修信息
  add_decoration_info: `${FCAPI}/shang/ruan/user/house`, // 新增或者编辑装修信息
  edit_name: `${FCAPI}/shang/ruan/user/profile/name/`, // 编辑姓名
  edit_city: `${FCAPI}/shang/ruan/user/profile/city/`, // 编辑城市
  edit_wechat: `${FCAPI}/shang/ruan/user/profile/wechat/`, // 编辑微信号
  region_list: '/region.json', // 地区列表
  list: `${FCAPI}/shang/ruan/setting/butler`, // 管家列表
  edit_ruan_detail: `${FCAPI}/shang/ruan/user/profile/`, // 编辑软装详情
  apply_list: `${FCAPI}/shang/ruan/user/apply`, // 获取报名列表
  remark: `${FCAPI}/shang/ruan/user/remark`, // 跟进记录列表
  add_mobile: `${FCAPI}/shang/ruan/user/profile/mobile/`, // 新增关联手机号
  delete_mobile: `${FCAPI}/shang/ruan/user/profile/mobile/`, // 解除关联手机号
  add_remark: `${FCAPI}/shang/ruan/user/remark`, // 添加跟进记录
  visit: `${FCAPI}/shang/ruan/user/status/visit/`, // 切换至到店状态
  deposit: `${FCAPI}/shang/ruan/user/status/deposit/`, // 切换至下订状态
  invalid: `${FCAPI}/shang/ruan/user/status/invalid/`, // 切换至无效状态
  refund: `${FCAPI}/shang/ruan/user/status/refund/`, // 切换至退单状态
  sign_status: `${FCAPI}/shang/ruan/user/status/sign/`, // 切换至签约状态
  wait: `${FCAPI}/shang/ruan/user/status/wait/`, // 切换至待定状态
  deposit_api: `${FCAPI}/shang/ruan/user/order/deposit`, // get获取下订列表，post新增下订，put编辑下订
  sign_api: `${FCAPI}/shang/ruan/user/order/sign`, // get获取签约列表，post新增签约，put编辑签约
  refund_api: `${FCAPI}/shang/ruan/user/order/refund`, // get获取退单列表，post新增退单，put编辑退单
  contract: `${FCAPI}/shang/ruan/contract`, // 获取合同列表
  edit_apply_stage: `${FCAPI}/shang/ruan/user/apply/stage/`, // 编辑预约阶段
  get_apply_count: `${FCAPI}/shang/ruan/user/apply/count`, // 获取报名次数
};
import storage from 'baimahu/storage';
const profile = storage.getItem('profile');
interface DecorationModel {
  id: number;
  user_id: number;
  province_id: number;
  province_name: string;
  city_id: number;
  city_name: string;
  address: string;
  type: number;
  area: number;
  create_time: number;
  subscribe_time: number;
}
function initDecorationInfoData(remote?: FcapiRemotePagination<DecorationModel>) {
  remote = remote || ({} as FcapiRemotePagination<DecorationModel>);
  return {
    current: remote.current || 0,
    limit: remote.limit || 0,
    detail: remote.detail || [],
    total: remote.total || 0,
    last: remote.last || 0,
  };
}
function initUserInfo(remote?: any) {
  remote = remote || {};
  return {
    name: remote.name || '',
    mobile: remote.mobile || '',
    city: remote.city || '',
    wechat_list: remote.wechat_list ? remote.wechat_list : '',
    callback_time: remote.callback_time ? moment(remote.callback_time * 1000) : null,
    decoration_budget: remote.decoration_budget ? (remote.decoration_budget / 100).toFixed(2) : '',
    decoration_style: remote.decoration_style || undefined,
    decoration_stage: remote.decoration_stage || undefined,
    status: remote.status || '',
    tag: remote.tag || undefined,
    assistant_id: remote.assistant_id || undefined,
    update_time: remote.update_time || '',
    relevance_mobile: remote.relevance_mobile || [],
    mobile_list: remote.mobile_relevance ? remote.mobile_relevance : '',
    sub_status: remote.sub_status || 0,
    apply_count: 0,
    plan_visit_time: remote.plan_visit_time || null,
  };
}
// 初始化新增装修信息form
function initAddDecorationForm(remote?: any) {
  remote = remote || {};
  return {
    id: remote.id || '',
    city_id: remote.city_id ? remote.city_id.toString() : '3301',
    city_name: remote.city_name || '',
    province_id: remote.province_id ? remote.province_id.toString() : '33',
    province_name: remote.province_name || '',
    address: remote.address || '',
    type: remote.type || undefined,
    area: remote.area || '',
  };
}
// 初始化新增下订模态窗验证值
function initDepositValidatorMap() {
  return {
    money: {
      field: 'money',
      validate: (value: string): boolean => !!value,
      message: '请输入订金金额',
    },
    brand: {
      field: 'brand',
      validate: (value: any): boolean => !!value.length,
      message: '请选择下订品牌',
    },
    img: {
      field: 'img',
      validate: (value: any): boolean => !!value.length,
      message: '请上传图片',
    },
    plan_sign_time: {
      field: 'plan_sign_time',
      validate: (value: any): boolean => !!value,
      message: '请选择预估签约时间',
    },
  };
}
// 初始化新增签约模态窗验证
function initSignValidatorMap() {
  return {
    order: {
      field: 'order',
      validate: (value: string): boolean => !!value,
      message: '请选择绑定订金单',
    },
    money1: {
      field: 'money1',
      validate: (value: string): boolean => !!value,
      message: '请输入签约金额',
    },
    brand1: {
      field: 'brand1',
      validate: (value: string): boolean => !!value && !!value.length,
      message: '请选择签约品牌',
    },
    start_time: {
      field: 'start_time',
      validate: (value: string): boolean => !!value,
      message: '请选择签约时间',
    },
    send_time: {
      field: 'send_time',
      validate: (value: string): boolean => value.length >= 2,
      message: '请选择预估送货时间',
    },
    img: {
      field: 'img',
      validate: (value: string): boolean => !!value.length,
      message: '请上传合同图片',
    },
  };
}
// 初始化新增退单模态窗验证
function initRefundValidatorMap() {
  return {
    order: {
      field: 'order',
      validate: (value: string): boolean => !!value,
      message: '请选择绑定订金单',
    },
    money: {
      field: 'money',
      validate: (value: string): boolean => !!value,
      message: '请输入退单金额',
    },
    brand: {
      field: 'brand',
      validate: (value: string): boolean => !!value && !!value.length,
      message: '请选择退单品牌',
    },
    refund_cause: {
      field: 'refund_cause',
      validate: (value: string): boolean => !!value,
      message: '请选择退单原因',
    },
  };
}
function initEditInfoValidatorMap() {
  return {
    name: {
      status: '',
      help: '',
      valuedate: (value: string): boolean => !!value,
    },
    city: {
      status: '',
      help: '',
      valuedate: (value: string): boolean => !!value,
    },
    mobile: {
      status: '',
      help: '',
      valuedate: (value: string): boolean => !!value,
    },
    wechat_id: {
      status: '',
      help: '',
      valuedate: (value: string): boolean => !!value,
    },
  };
}
// 初始新增装修信息模态窗表单验证项
function initAddDecorationValidateMap() {
  return {
    address: {
      field: 'address',
      message: '请输入小区地址',
      validate: (value: any): boolean => !!value,
    },
    city_id: {
      field: 'city_id',
      message: '请选择装修区域',
      validate: (value: any): boolean => !!value,
    },
  };
}
@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload,
    Space,
  },
})
export default class UserDetail extends Vue {
  add_decoration_info_form: any = initAddDecorationForm();
  add_decoration_info_modal_valiedateMap: any = initAddDecorationValidateMap();
  apply_data: any = initDecorationInfoData();
  // 新增下订模态窗值
  add_deposit_modal_value: any = {
    money: '',
    brand: [],
    img: [],
    is_edit: false,
    item_id: 0,
    plan_sign_time: null,
  };
  // 新增下订模态窗验证
  deposit_modal_validator: any = initDepositValidatorMap();
  // 新增签约模态窗值
  add_sign_modal_value: any = {
    order: undefined,
    money1: '',
    brand1: [],
    money2: '',
    brand2: [],
    start_time: moment(new Date()),
    send_time: [],
    img: [],
    is_split: false,
    is_edit: false,
    select_value: [],
    id: '',
    select_order: {},
  };
  // 新增签约模态窗验证
  sign_modal_validator: any = initSignValidatorMap();
  // 新增退单模态窗值
  add_refund_modal_value: any = {
    order: undefined,
    money: '',
    is_edit: false,
    brand: [],
    refund_cause: undefined,
    select_value: [],
    select_order: {},
  };
  // 城市列表
  city_list: any = [];
  // 编辑报名阶段模态窗值
  edit_apply_stage: any = {
    stage: undefined,
    item: {},
  }; // 编辑预约阶段；
  // 新增退单模态窗验证
  refund_modal_validator: any = initRefundValidatorMap();
  // 编辑软装详情模态窗验证项
  ruan_detail_modal_validator: any = {
    assistant: {
      status: '',
      help: '',
      validate: (value: string): boolean => !!value,
    },
  };
  region_list: any = [];
  contract_list: any = []; // 合同列表
  decoration_data: FcapiRemotePagination<DecorationModel> = initDecorationInfoData(); // 装修信息
  is_edit_decoration: boolean = false; // 是否是编辑装修信息
  is_loading: boolean = false;
  is_show_add_info_modal: boolean = false; // 是否显示新增装修信息模态窗
  is_show_edit_modal: boolean = false; // 是否显示编辑软装状态模态窗
  is_show_apply_modal: boolean = false; // 是否展示下订状态模态窗
  is_show_signed_modal: boolean = false; // 是否展示新增签约模态窗
  is_show_chargeback_modal: boolean = false; // 是否展示退单模态窗
  is_show_check_img_modal: boolean = false; // 是否展示查看签约合同模态窗
  is_show_edit_stage_modal: boolean = false; // 是否展示编辑预约阶段模态窗
  form_item_layout: any = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
  };
  check_img: string = '';
  // 编辑姓名，手机号，城市，模态窗
  modal_config: any = {
    modal_title: '编辑姓名',
    type: 1, // 1 姓名， 2 手机号， 3 城市 4 微信
    is_show: false,
    value: '',
  };
  // 修改信息模态窗表单验证项
  modal_config_validator_map: any = initEditInfoValidatorMap();
  remark: string = '';
  remark_data: any = [];
  remark_string: string = '';
  remark_page: number = 1;
  steward_data: any = []; // 软装管家列表
  // 软装状态流转
  status_change_value: any = {
    undetermind_cause: undefined, // 待定
    detail: undefined, // 到店细节
    invalid: undefined, // 无效
    set_up: {}, // 下订
    signed: {}, // 签约
    chargeback: {}, // 退单
    status: '', /// 当前状态
    visit_time: null,
  };
  province_list_all: any = []; // 地区列表
  picture_form: any = {};
  user_info: any = initUserInfo(); // 用户信息
  user_id: number = -1; // 用户id
  validatorMap: any = {
    undetermind_cause: {
      status: '',
      help: '',
    },
    visit_time: {
      status: '',
      help: '',
    },
    detail: {
      status: '',
      help: '',
    },
    invalid: {
      status: '',
      help: '',
    },
  };
  // 房型
  get houseType() {
    return HOUSE_TYPE;
  }
  get houstTypeMap() {
    return _.keyBy(this.houseType, 'value');
  }
  // 装修阶段
  get decorationStage() {
    return DECORATION_STAGE;
  }
  get decorationStageMap() {
    return _.keyBy(this.decorationStage, 'value');
  }
  // 软装状态
  get ruanStatus() {
    return RUAN_STATUS;
  }
  get ruanStatusMap() {
    return _.keyBy(RUAN_STATUS, 'value');
  }
  // 软装风格
  get style() {
    return STYLE;
  }
  get styleMap() {
    return _.keyBy(STYLE, 'value');
  }
  // 软装管家
  get stewardDataMap() {
    return _.keyBy(this.steward_data, 'id');
  }
  // 无效原因
  get invalidCause() {
    return INVALID_CAUSE;
  }
  // 待定原因
  get undetermindCause() {
    return UNDETERMINED_CAUSE;
  }

  get uploadDir() {
    return UPLOAD_DIR;
  }

  get refundCauseMap() {
    return _.keyBy(REFUND_CAUSE, 'value');
  }

  get refundCause() {
    return REFUND_CAUSE;
  }

  handlePreview(image_url: string) {
    this.is_show_check_img_modal = true;
    this.check_img = image_url;
  }

  dateFormat(time: any, type: string = '%Y-%m-%d %H:%M:%S') {
    return dateFormat(new Date(time * 1000), type);
  }

  moment(value: any) {
    return moment.utc(value).format('YYYY-MM-DD');
  }

  paginationOption(data: any) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  commonBeforeUpload(file: any) {
    if (file.size / 1024 / 1024 > 2) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
  }

  // 切换定金单
  changeOrder() {
    console.log(this.add_refund_modal_value);
    this.add_refund_modal_value.select_value.forEach((item: any) => {
      if (this.add_refund_modal_value.order === item.id) {
        this.add_refund_modal_value.money = (item.amount / 100).toFixed(2);
        this.add_refund_modal_value.brand = item.brand_json.map((item: any) => item.id);
      }
    });
  }

  // 点击编辑预约阶段按钮
  clickApplyEditBtn(item: any) {
    this.is_show_edit_stage_modal = true;
    this.edit_apply_stage.stage = item.subscribe_stage;
    this.edit_apply_stage.item = item;
  }
  // 关闭编辑预约阶段模态窗
  closeEditApplyStage() {
    this.is_show_edit_stage_modal = false;
    this.edit_apply_stage.stage = undefined;
    this.edit_apply_stage.item = {};
  }

  // 点击拆单按钮
  clickSplitBtn() {
    this.add_sign_modal_value.is_split = true;
    this.sign_modal_validator.money2 = {
      field: 'money2',
      validate: (value: string): boolean => !!value,
      message: '请输入签约金额',
    };
    this.sign_modal_validator.brand2 = {
      field: 'brand2',
      validate: (value: string): boolean => !!value,
      message: '请选择签约品牌',
    };
    this.$forceUpdate();
  }

  // 关闭新增装修信息模态窗
  closeAddDecorationModal() {
    this.is_show_add_info_modal = false;
    this.add_decoration_info_form = initAddDecorationForm();
    this.is_edit_decoration = false;
    this.add_decoration_info_modal_valiedateMap = initAddDecorationValidateMap();
    this.region_list.forEach((item: any) => {
      if (item.id === '33') {
        this.city_list = item.children;
      }
    });
  }

  // 点击编辑操作
  clickEditBtn(item: any) {
    this.is_show_add_info_modal = true;
    this.is_edit_decoration = true;
    this.add_decoration_info_form = initAddDecorationForm(item);
    if (!(item.province_id)) {
      this.add_decoration_info_form.province_id = undefined;
      this.add_decoration_info_form.city_id = undefined;
    }
    console.log(this.add_decoration_info_form);
    const data = JSON.parse(JSON.stringify(this.add_decoration_info_form));
    storage.setItem('picture_form', {
      id: item.id,
      province_id: data.province_id + '',
      city_id: data.city_id + '',
      address: data.address,
      type: data.type,
      area: data.area,
    });
    this.region_list.forEach((item2: any) => {
      if (item.province_id + '' === item2.id) {
        this.city_list = item2.children;
      }
    });
  }

  // 关闭修改基本信息模态窗
  closeModifyUserInfoModal() {
    this.modal_config_validator_map = initEditInfoValidatorMap();
    this.modal_config.is_show = false;
    this.modal_config.value = '';
  }

  // 关闭新增下订模态窗
  closeDepositModal() {
    this.is_show_apply_modal = false;
    this.add_deposit_modal_value = {
      money: '',
      brand: [],
      img: [],
      is_edit: false,
      plan_sign_time: null,
    };
    this.deposit_modal_validator = initDepositValidatorMap();
  }

  // 编辑姓名
  editName() {
    this.modal_config.is_show = true;
    this.modal_config.type = 1;
    this.modal_config.value = this.user_info.name;
    this.modal_config.modal_title = '编辑姓名';
  }

  // 编辑城市
  editCity() {
    this.modal_config.is_show = true;
    this.modal_config.value = this.user_info.city;
    this.modal_config.type = 3;
    this.modal_config.modal_title = '编辑城市';
  }

  // 编辑微信
  editWechat() {
    this.modal_config.is_show = true;
    this.modal_config.type = 4;
    this.modal_config.modal_title = '添加微信号';
    this.modal_config.value = this.user_info.wechat_list;
  }

  // 展示修改关联手机号模态窗
  showEditMobile() {
    console.log(this.user_info);
    this.modal_config.is_show = true;
    this.modal_config.modal_title = '编辑关联手机号';
    this.modal_config.type = 2;
    this.modal_config.value = this.user_info.mobile_list;
  }

  // 关闭添加签约模态窗
  @changeLoading(['is_loading'])
  async closeAddSignModal() {
    this.is_show_signed_modal = false;
    this.add_sign_modal_value = {
      order: undefined,
      money1: '',
      brand1: undefined,
      money2: '',
      brand2: undefined,
      start_time: moment(new Date()),
      send_time: [],
      img: [],
      is_split: false,
      is_edit: false,
      id: '',
    };
    this.sign_modal_validator = initSignValidatorMap();
    await this.getAllDepositData();
  }

  // 关闭添加退单模态窗
  @changeLoading(['is_loading'])
  async closeRefundModal() {
    this.is_show_chargeback_modal = false;
    this.add_refund_modal_value = {
      order: undefined,
      money: '',
      is_edit: false,
      brand: undefined,
      refund_cause: undefined,
      select_value: [],
    };
    this.refund_modal_validator = initRefundValidatorMap();
    await this.getAllDepositData();
  }

  // 点击编辑软装详情按钮
  clickEditRuanDetail() {
    this.is_show_edit_modal = true;
    const data = JSON.parse(JSON.stringify(this.user_info));
    this.picture_form = {
      decoration_stage_name: this.decorationStageMap[data.decoration_stage]
        ? this.decorationStageMap[data.decoration_stage].label
        : '',
      decoration_stage: data.decoration_stage,
      tag_name: data.tag === 1 ? '重要' : '一般',
      tag: data.tag,
      assistant_id: data.assistant_id,
      decoration_budget: data.decoration_budget * 100,
      decoration_style: data.decoration_style,
      callback_time: this.user_info.callback_time,
    };
  }

  // 编辑签约
  editSign(item: any) {
    this.is_show_signed_modal = true;
    this.add_sign_modal_value = {
      order: item.deposit_id,
      money1: (item.amount / 100).toFixed(2),
      brand1: item.brand_json.map((item: any) => item.id),
      start_time: moment(item.sign_time * 1000),
      send_time: [moment(item.express_start_time * 1000), moment(item.express_end_time * 1000)],
      img: item.image_list,
      is_edit: true,
      id: item.id,
      select_value: [],
      select_order: this.status_change_value.set_up.detail.filter((item2: any) => item2.id === item.deposit_id)[0],
    };
  }

  // 编辑退单
  editRefund(item: any) {
    this.is_show_chargeback_modal = true;
    this.add_refund_modal_value.is_edit = true;
    this.add_refund_modal_value.money = (item.amount / 100).toFixed(2);
    this.add_refund_modal_value.brand = item.brand_json.map((item: any) => item.id);
    this.add_refund_modal_value.refund_cause = item.refund_reason;
    this.add_refund_modal_value.order = item.id;
    this.add_refund_modal_value.select_order = this.status_change_value.set_up.detail.filter(
      (item2: any) => item2.id === item.id
    )[0];
  }

  validateCommit(form_value: any, validatorMap: any) {
    const form = form_value as any;
    let is_valid: boolean = true;
    _.each(validatorMap, (validator: any, field: string) => {
      if (!this.validate(field, validatorMap, form_value)) {
        is_valid = false;
      }
    });
    if (!is_valid) {
      this.$message.error('请填入必填项');
      return false;
    }
    return is_valid;
  }
  validate(field: string, validatorMap: any, form_value: any) {
    const form = form_value as any;
    const is_valid = validatorMap[field] ? validatorMap[field].validate(form_value[field], form_value) : '';
    if (validatorMap[field]) {
      validatorMap[field].status = is_valid ? 'success' : 'error';
      validatorMap[field].help = is_valid ? '' : validatorMap[field].message;
      return is_valid;
    }
  }

  // 切换省份
  changeProvince(province_id: number) {
    this.add_decoration_info_form.city_id = undefined;
    this.region_list.forEach((item: any) => {
      if (province_id === item.id) {
        this.city_list = item.children;
      }
    });
  }

  formatDeposit(id: any) {
    const format_str = '00000000';
    id = '' + id;
    return `D${format_str.substr(0, 8 - id.length)}${id}`;
  }

  // 点击新增签约按钮
  @changeLoading(['is_loading'])
  async clickAddSignBtn() {
    this.is_show_signed_modal = true;
    await this.getAllDepositData(); // 获取全部下订列表
  }

  @changeLoading(['is_loading'])
  async updateApplyStage() {
    const res = await this.$axios.put(`${API.edit_apply_stage}${this.edit_apply_stage.item.id}`, {
      subscribe_stage: this.edit_apply_stage.stage,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.closeEditApplyStage();
    this.$message.success('编辑预约阶段成功');
    await this.getApplyList();
  }

  // 获取所有合同
  @changeLoading(['is_loading'])
  async getContractData() {
    const url = getUrl(API.contract, {
      current: 1,
      limit: 10000,
      status: 1,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.contract_list = res.data.data ? res.data.data.detail : [];
  }

  // 删除微信号
  @changeLoading(['is_loading'])
  async deleteWechat(index: number) {
    const wechat_id = this.user_info.wechat_list[index];
    const arr = JSON.parse(JSON.stringify(this.user_info.wechat_list));
    arr.splice(index, 1);
    const res = await this.$axios.put(`${API.edit_wechat}${this.user_id}`, {
      wechat_list: arr,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('删除成功');
    await this.getUserDetail();
    this.remark = `删除微信号【${wechat_id}】`;
    await this.addRemark();
  }

  // 删除手机号
  @changeLoading(['is_loading'])
  async deleteMobile(index: number) {
    const mobile = this.user_info.mobile_list[index];
    this.user_info.mobile_list.splice(index, 1);
    const res = await this.$axios.put(`${API.add_mobile}${this.user_id}`, {
      mobile_relevance: this.user_info.mobile_list,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('删除成功');
    await this.getUserDetail();
    this.remark = `删除关联手机号【${mobile}】`;
    await this.addRemark();
  }

  // 获取报名次数
  @changeLoading(['is_loading'])
  async getApplyCount() {
    const url = getUrl(API.get_apply_count, {
      user_id: this.user_id,
      type: 1,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.user_info.apply_count = res.data.data.count;
  }

  // 添加跟进记录
  @changeLoading(['is_loading'])
  async addRemark(is_submit?: boolean) {
    if (is_submit) {
      this.remark = `新增跟进备注【${this.remark}】`;
    }
    const res = await this.$axios.post(API.add_remark, {
      user_id: this.user_id,
      content: this.remark,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.remark = '';
    await this.remarkData();
  }

  // 新增退单
  @changeLoading(['is_loading'])
  async addRefund() {
    if (!this.validateCommit(this.add_refund_modal_value, this.refund_modal_validator)) {
      return;
    }
    const data = this.add_refund_modal_value;
    const send_data: any = {
      user_id: this.user_id,
      deposit_id: data.order,
      refund_amount: data.money * 100,
      refund_brand_json: [],
      refund_reason: data.refund_cause,
    };
    this.contract_list.forEach((item: any) => {
      if (data.brand.indexOf(item.id) !== -1) {
        send_data.refund_brand_json.push({
          id: item.id,
          name: item.brand_name,
        });
      }
    });
    let res;
    if (data.is_edit) {
      res = await this.$axios.put(`${API.refund_api}/${data.order}`, send_data);
    } else {
      res = await this.$axios.post(API.refund_api, send_data);
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success(data.is_edit ? '编辑退单成功' : '新增退单成功');
    this.closeRefundModal();
    await this.getRefundData({
      user_id: this.user_id,
      current: 1,
    });
  }

  // 获取退单列表
  @changeLoading(['is_loading'])
  async getRefundData(query_params: any) {
    const url = getUrl(API.refund_api, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.status_change_value.chargeback = initDecorationInfoData(res.data.data);
    this.status_change_value.chargeback.detail.forEach((item: any, index: number) => {
      item.sort = (this.status_change_value.chargeback.current - 1) * 5 + (index + 1);
      item.brand_json = item.brand_json ? JSON.parse(item.brand_json) : [];
      item.refund_brand_json = item.refund_brand_json ? JSON.parse(item.refund_brand_json) : [];
      item.image_list = item.image_list.split(',');
    });
  }

  // 切换退单分页
  @changeLoading(['is_loading'])
  async handleRefundChange(data: any) {
    await this.getRefundData({
      user_id: this.user_id,
      current: data.current,
    }); // 获取退单列表
  }

  // 流转状态
  @changeLoading(['is_loading'])
  async changeStatus() {
    const user = this.user_info;
    const active_status = this.status_change_value;
    if (active_status.status === 1 || active_status.status === 2) {
      this.$message.error('请先选择下一状态');
      return;
    }
    if (user.status === active_status.status) {
      this.$message.error('不能流转至该状态');
      return;
    }
    if (user.status === 1 || user.status === 2) {
      if (!active_status.undetermind_cause) {
        this.validatorMap.undetermind_cause.status = 'error';
        this.validatorMap.undetermind_cause.help = '请选择待定原因';
      } else if (active_status.undetermind_cause === 6 && !active_status.visit_time) {
          this.validatorMap.visit_time.status = 'error';
          this.validatorMap.visit_time.help = '请选择预估到店时间';
      } else {
        this.validatorMap.undetermind_cause.status = '';
        this.validatorMap.undetermind_cause.help = '';
        this.validatorMap.visit_time.status = '';
        this.validatorMap.visit_time.help = '';
        const status = user.status === 1 ? '注册' : user.status === 2 ? '报名' : '';
        this.remark = `状态流转从【${status}】修改为【待定】`;
        await this.changeWait();
        await this.getUserDetail();
      }
      if (
        active_status.status === 4 ||
        active_status.status === 5 ||
        active_status.status === 6 ||
        active_status.status === 7 ||
        active_status.status === 8
      ) {
        this.$message.error('不能流转至该状态');
      }
    }
    if (user.status === 3) {
      if (active_status.status === 4) {
        if (!active_status.detail) {
          this.validatorMap.detail.status = 'error';
          this.validatorMap.detail.help = '请选择待定原因';
        } else {
          this.validatorMap.detail.status = '';
          this.validatorMap.detail.help = '';
          this.remark = `状态流转从【待定】修改为【到店】`;
          await this.changeVisit();
          await this.getUserDetail();
        }
      } else if (active_status.status === 7) {
        if (!active_status.invalid) {
          this.validatorMap.invalid.status = 'error';
          this.validatorMap.invalid.help = '请选择待定原因';
        } else {
          this.validatorMap.invalid.status = '';
          this.validatorMap.invalid.help = '';
          this.remark = `状态流转从 【待定】修改为【无效】`;
          await this.changeInvalid();
          await this.getUserDetail();
        }
      } else {
        this.$message.error('不能流转至该状态');
      }
    }
    if (user.status === 4) {
      if (active_status.status === 3) {
        if (!active_status.undetermind_cause) {
          this.validatorMap.undetermind_cause.status = 'error';
          this.validatorMap.undetermind_cause.help = '请选择待定原因';
        } else {
          this.validatorMap.undetermind_cause.status = '';
          this.validatorMap.undetermind_cause.help = '';
          this.remark = `状态流转从 【到店】修改为【待定】`;
          await this.changeWait();
          await this.getUserDetail();
        }
      } else if (active_status.status === 7) {
        if (!active_status.invalid) {
          this.validatorMap.invalid.status = 'error';
          this.validatorMap.invalid.help = '请选择待定原因';
        } else {
          this.validatorMap.invalid.status = '';
          this.validatorMap.invalid.help = '';
          this.remark = `状态流转从 【到店】修改为【无效】`;
          await this.changeInvalid();
          await this.getUserDetail();
        }
      } else if (active_status.status === 5) {
        if (!active_status.set_up.detail.length) {
          this.$message.error('请选择下订订单');
        } else {
          this.remark = `状态流转从 【到店】修改为【下订】`;
          await this.changeDeposit();
          await this.getUserDetail();
        }
      } else {
        this.$message.error('不能流转至该状态');
      }
    }
    if (user.status === 5) {
      if (active_status.status === 8) {
        if (!active_status.chargeback.detail.length) {
          this.$message.error('请选择退单订单');
        } else {
          this.remark = `状态流转从 【下订】修改为【退单】`;
          await this.changeRefund();
          await this.getUserDetail();
        }
      } else if (active_status.status === 6) {
        if (!active_status.signed.detail.length) {
          this.$message.error('请选择签约订单');
        } else {
          this.remark = `状态流转从 【下订】修改为【签约】`;
          await this.changeSign();
          await this.getUserDetail();
        }
      } else {
        this.$message.error('不能流转至该状态');
      }
    }
    if (user.status === 7) {
      if (active_status.status === 3) {
        if (!active_status.undetermind_cause) {
          this.validatorMap.undetermind_cause.status = 'error';
          this.validatorMap.undetermind_cause.help = '请选择待定原因';
        } else {
          this.validatorMap.undetermind_cause.status = '';
          this.validatorMap.undetermind_cause.help = '';
          this.remark = `状态流转从 【无效】修改为【待定】`;
          await this.changeWait();
          await this.getUserDetail();
        }
      } else {
        this.$message.error('不能流转至该状态');
      }
    }
    if (user.status === 6 || user.status === 8) {
      if (active_status.status !== user.status) {
        this.$message.error('无法流转至该状态');
      }
    }
  }

  // 切换下订分页
  @changeLoading(['is_loading'])
  async handleSetUpChange(data: any) {
    await this.getDepositData({
      user_id: this.user_id,
      current: data.current,
      status: '0',
    }); // 获取地区列表
  }

  // 获取下订列表
  @changeLoading(['is_loading'])
  async getDepositData(query_params: any) {
    const url = getUrl(API.deposit_api, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.status_change_value.set_up = initDecorationInfoData(res.data.data);
    this.status_change_value.set_up.detail.forEach((item: any, index: number) => {
      item.sort = (this.status_change_value.set_up.current - 1) * 5 + (index + 1);
      item.brand_json = item.brand_json ? JSON.parse(item.brand_json) : [];
      item.refund_brand_json = item.refund_brand_json ? JSON.parse(item.refund_brand_json) : [];
      item.image_list = item.image_list.split(',');
    });
  }

  // 获取全部下订列表
  @changeLoading(['is_loading'])
  async getAllDepositData() {
    const url = getUrl(API.deposit_api, {
      is_all: 1,
      status: 1,
      user_id: this.user_id,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const data = res.data.data || [];
    data.forEach((item: any) => {
      item.brand_json = item.brand_json ? JSON.parse(item.brand_json) : [];
      item.refund_brand_json = item.refund_brand_json ? JSON.parse(item.refund_brand_json) : [];
      item.image_list = item.image_list.split(',');
    });
    this.add_sign_modal_value.select_value = data;
    this.add_refund_modal_value.select_value = data;
  }

  // 新增下订
  @changeLoading(['is_loading'])
  async addDeposit() {
    if (!this.validateCommit(this.add_deposit_modal_value, this.deposit_modal_validator)) {
      return;
    }
    // 小于4证明该用户当前状态为 1 || 2 || 3(注册 || 报名 || 待定);
    if (this.user_info.status < 4) {
      this.closeDepositModal();
      this.$message.error('不能流转至该状态');
      return;
    }
    let res;
    const send_data: any = {
      user_id: this.user_id,
      amount: this.add_deposit_modal_value.money * 100,
      image_list: this.add_deposit_modal_value.img,
      brand_json: [],
      plan_sign_time: this.add_deposit_modal_value.plan_sign_time.format('X'),
    };
    this.contract_list.forEach((item: any) => {
      if (this.add_deposit_modal_value.brand.indexOf(item.id) !== -1) {
        send_data.brand_json.push({
          id: item.id,
          name: item.brand_name,
        });
      }
    });
    if (this.add_deposit_modal_value.is_edit) {
      res = await this.$axios.put(`${API.deposit_api}/${this.add_deposit_modal_value.item_id}`, send_data);
    } else {
      res = await this.$axios.post(API.deposit_api, send_data);
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success(this.add_deposit_modal_value.is_edit ? '编辑下订成功' : '新增下订成功');
    this.closeDepositModal();
    await this.getDepositData({
      user_id: this.user_id,
      current: 1,
      status: '0',
    }); // 获取地区列表
    await this.getAllDepositData();
  }

  // 编辑下订
  editDeposit(item: any) {
    console.log(item);
    this.add_deposit_modal_value = {
      money: item.amount / 100,
      brand: item.brand_json.map((item: any) => item.id),
      img: item.image_list,
      is_edit: true,
      item_id: item.id,
      plan_sign_time: moment(item.plan_sign_time * 1000),
    };
    this.is_show_apply_modal = true;
  }

  // 切换至下订状态
  @changeLoading(['is_loading'])
  async changeDeposit() {
    const res = await this.$axios.put(`${API.deposit}${this.user_id}`);
    if (res.data.status !== 200) {
      return;
    }
    await this.addRemark();
    await this.getUserDetail();
    this.$message.success('状态流转成功');
  }

  // 切换至签约状态
  @changeLoading(['is_loading'])
  async changeSign() {
    const res = await this.$axios.put(`${API.sign_status}${this.user_id}`);
    if (res.data.status !== 200) {
      return;
    }
    await this.addRemark();
    await this.getUserDetail();
    this.$message.success('状态流转成功');
  }

  // 切换至到店状态
  @changeLoading(['is_loading'])
  async changeVisit() {
    const res = await this.$axios.put(`${API.visit}${this.user_id}`, {
      type: this.status_change_value.detail,
    });
    if (res.data.status !== 200) {
      return;
    }
    await this.addRemark();
    await this.getUserDetail();
    this.$message.success('状态流转成功');
  }

  // 切换至待定状态
  @changeLoading(['is_loading'])
  async changeWait() {
    const send_data: any = {
      type: this.status_change_value.undetermind_cause,
    };
    if (send_data.type === 6 && this.status_change_value.visit_time) {
      send_data.plan_visit_time = this.status_change_value.visit_time.format('X');
    }
    const res = await this.$axios.put(`${API.wait}${this.user_id}`, send_data);
    if (res.data.status !== 200) {
      return;
    }
    await this.addRemark();
    await this.getUserDetail();
    this.$message.success('状态流转成功');
  }

  // 切换至无效状态
  @changeLoading(['is_loading'])
  async changeInvalid() {
    const res = await this.$axios.put(`${API.invalid}${this.user_id}`, {
      type: this.status_change_value.invalid,
    });
    if (res.data.status !== 200) {
      return;
    }
    await this.addRemark();
    await this.getUserDetail();
    this.$message.success('状态流转成功');
  }

  // 切换至退单
  @changeLoading(['is_loading'])
  async changeRefund() {
    const res = await this.$axios.put(`${API.refund}${this.user_id}`);
    if (res.data.status !== 200) {
      return;
    }
    await this.addRemark();
    await this.getUserDetail();
    this.$message.success('状态流转成功');
  }

  // 获取签约列表
  @changeLoading(['is_loading'])
  async getSignData(
    query_params: any = {
      current: 1,
    }
  ) {
    const url = getUrl(API.sign_api, {
      user_id: this.user_id,
      ...query_params,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.status_change_value.signed = initDecorationInfoData(res.data.data);
    this.status_change_value.signed.detail.forEach((item: any, index: number) => {
      item.sort = (this.status_change_value.signed.current - 1) * 5 + (index + 1);
      item.brand_json = JSON.parse(item.brand_json);
      item.image_list = item.image_list.split(',');
      item.deposit.brand_json = item.deposit.brand_json ? JSON.parse(item.deposit.brand_json) : [];
    });
  }

  // 切换签约列表分页
  @changeLoading(['is_loading'])
  async handleSignChange(data: any) {
    await this.getSignData({
      current: data.current,
    });
  }

  // 新增签约列表
  @changeLoading(['is_loading'])
  async addSignModal() {
    if (!this.validateCommit(this.add_sign_modal_value, this.sign_modal_validator)) {
      return;
    }
    const data = this.add_sign_modal_value;
    let res;
    const send_data: any = {
      user_id: this.user_id,
      deposit_id: data.order,
      sign_time: data.start_time.format('X'),
      express_start_time: data.send_time[0].format('X'),
      express_end_time: data.send_time[1].format('X'),
      image_list: data.img,
    };
    if (data.is_edit) {
      send_data.brand_json = [];
      this.contract_list.forEach((item: any) => {
        if (data.brand1.indexOf(item.id) !== -1) {
          send_data.brand_json.push({
            id: item.id,
            name: item.brand_name,
          });
        }
      });
      send_data.amount = data.money1 * 100;
      res = await this.$axios.put(`${API.sign_api}/${data.id}`, send_data);
    } else {
      send_data.brand_list = [
        {
          amount: data.money1 * 100,
          brand_json: [],
        },
      ];
      this.contract_list.forEach((item: any) => {
        if (data.brand1.indexOf(item.id) !== -1) {
          send_data.brand_list[0].brand_json.push({
            id: item.id,
            name: item.brand_name,
          });
        }
      });
      if (data.is_split) {
        send_data.brand_list.push({
          amount: data.money2 * 100,
          brand_json: [],
        });
        this.contract_list.forEach((item: any) => {
          if (data.brand2.indexOf(item.id) !== -1) {
            send_data.brand_list[1].brand_json.push({
              id: item.id,
              name: item.brand_name,
            });
          }
        });
      }
      res = await this.$axios.post(API.sign_api, send_data);
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success(data.is_edit ? '编辑签约成功' : '新增签约成功');
    this.closeAddSignModal();
    await this.getSignData();
  }

  // 跟进记录滚动到底部使
  @changeLoading(['is_loading'])
  async onScroll(e: any) {
    const scrollTop = e.target.scrollTop;
    const clientHeight = e.target.clientHeight;
    const scrollHeight = e.target.scrollHeight;
    if (scrollTop + clientHeight > scrollHeight - 2) {
      this.remark_page++;
      await this.remarkData({
        current: this.remark_page,
        user_id: this.user_id,
      });
    }
  }

  // 跟进记录
  @changeLoading(['is_loading'])
  async remarkData(
    query_params: any = {
      current: this.remark_page,
      user_id: this.user_id,
    }
  ) {
    const url = getUrl(API.remark, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.remark_data.push(...res.data.data.detail);
    for (let i = 0; i < this.remark_data.length; i++) {
      this.remark_data[i] = JSON.stringify(this.remark_data[i]);
    }
    this.remark_data = Array.from(new Set(this.remark_data));
    for (let i = 0; i < this.remark_data.length; i++) {
      this.remark_data[i] = JSON.parse(this.remark_data[i]);
    }
    this.remark_page = this.remark_data.length > 10 ? Math.floor(this.remark_data.length / 10) : 1;
    this.remark_string = '';
    this.remark_data.sort((item1: any, item2: any) => item2.id - item1.id);
    this.remark_data.forEach((item: any) => {
      this.remark_string += `${this.dateFormat(item.create_time)} ${item.operator_name}: ${item.content}\r`;
    });
  }

  // 关闭编辑软装状态模态窗
  @changeLoading(['is_loading'])
  async closeEditRuanModal() {
    this.ruan_detail_modal_validator.assistant.status = '';
    this.ruan_detail_modal_validator.assistant.help = '';
    this.is_show_edit_modal = false;
    await this.getUserDetail();
  }

  // 切换装修信息分页
  @changeLoading(['is_loading'])
  async handleDecorationInfoChange(data: any) {
    await this.getDecorationInfo({
      user_id: this.user_id,
      current: data.current,
    });
  }

  // 编辑软装详情
  @changeLoading(['is_loading'])
  async editRuanDetail() {
    const data = this.user_info;
    if (!data.assistant_id) {
      this.ruan_detail_modal_validator.assistant.status = 'error';
      this.ruan_detail_modal_validator.assistant.help = '请选择软装管家';
      return;
    } else {
      this.ruan_detail_modal_validator.assistant.status = '';
      this.ruan_detail_modal_validator.assistant.help = '';
    }
    const send_data: any = {
      decoration_stage: data.decoration_stage,
      tag: data.tag,
      assistant_id: data.assistant_id,
      assistant_name: this.steward_data.filter((item: any) => item.id === data.assistant_id)[0].charge,
      decoration_style: data.decoration_style,
    };
    if (data.decoration_budget) {
      send_data.decoration_budget = data.decoration_budget * 100;
    }
    send_data.callback_time = data.callback_time ? data.callback_time.format('X') : '';
    this.picture_form.callback_time = this.picture_form.callback_time
      ? this.picture_form.callback_time.format('X')
      : '';
    const res = await this.$axios.put(`${API.edit_ruan_detail}${this.user_id}`, send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    let diff_prop: any = [];
    const obj_prop_arr = Object.keys(send_data);
    obj_prop_arr.forEach((item: any) => {
      if (send_data[item] !== this.picture_form[item]) {
        diff_prop.push(item);
      }
    });
    const field_map: any = {
      decoration_stage: '装修阶段',
      tag: '客户等级',
      assistant_id: '软装管家',
      decoration_budget: '软装预算',
      decoration_style: '软装风格偏好',
      callback_time: '下次回访',
    };
    this.remark = ``;
    diff_prop = diff_prop.filter((item: any) => item !== 'assistant_name');
    diff_prop.forEach((item: any) => {
      const field = field_map[item];
      let old_value;
      let new_value;
      if (item === 'decoration_budget') {
        old_value = this.picture_form[item] ? (this.picture_form[item] / 100).toFixed(2) : '';
        new_value = (send_data[item] / 100).toFixed(2);
      } else if (item === 'decoration_stage') {
        old_value = this.decorationStageMap[this.picture_form[item]]
          ? this.decorationStageMap[this.picture_form[item]].label
          : '';
        new_value = this.decorationStageMap[send_data[item]] ? this.decorationStageMap[send_data[item]].label : '';
      } else if (item === 'tag') {
        old_value = this.picture_form[item] === 1 ? '重要' : '一般';
        new_value = send_data[item] === 1 ? '重要' : '一般';
      } else if (item === 'decoration_style') {
        old_value = this.styleMap[this.picture_form[item]] ? this.styleMap[this.picture_form[item]].label : '';
        new_value = this.styleMap[send_data[item]] ? this.styleMap[send_data[item]].label : '';
      } else if (item === 'assistant_id') {
        old_value = this.stewardDataMap[this.picture_form[item]]
          ? this.stewardDataMap[this.picture_form[item]].charge
          : '';
        new_value = this.stewardDataMap[send_data[item]] ? this.stewardDataMap[send_data[item]].charge : '';
      } else if (item === 'callback_time') {
        // old_value = this.picture_form.callback_time ? moment(this.picture_form.callback_time).format('YYYY-MM-DD HH:mm:ss') : '';
        old_value = this.picture_form.callback_time ? this.dateFormat(this.picture_form.callback_time) : '';
        new_value = send_data.callback_time ? this.dateFormat(send_data.callback_time) : '';
      }

      this.remark += `${field}从【${old_value}】修改为【${new_value}】；`;
    });
    await this.addRemark();
    await this.closeEditRuanModal();
    this.$message.success('编辑成功');
  }

  // 获取管家列表
  @changeLoading(['is_loading'])
  async getList(
    query_params: any = {
      is_all: 1,
    }
  ) {
    const url = getUrl(API.list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.steward_data = res.data.data;
  }

  // 编辑基本信息
  @changeLoading(['is_loading'])
  async editUserInfo() {
    let res;
    if (this.modal_config.type === 1) {
      if (!this.modal_config.value) {
        this.modal_config_validator_map.name.status = 'error';
        this.modal_config_validator_map.name.help = '请填写姓名';
        return;
      } else {
        this.modal_config_validator_map.name.status = '';
        this.modal_config_validator_map.name.help = '';
      }
      this.remark = `姓名从【${this.user_info.name}】修改为【${this.modal_config.value}】`;
      await this.addRemark();
      res = await this.$axios.put(`${API.edit_name}${this.user_id}`, {
        name: this.modal_config.value,
      });
    } else if (this.modal_config.type === 3) {
      if (!this.modal_config.value) {
        this.modal_config_validator_map.city.status = 'error';
        this.modal_config_validator_map.city.help = '请填写城市';
        return;
      } else {
        this.modal_config_validator_map.city.status = '';
        this.modal_config_validator_map.city.help = '';
      }
      this.remark = `城市从【${this.user_info.city}】修改为【${this.modal_config.value}】`;
      await this.addRemark();
      res = await this.$axios.put(`${API.edit_city}${this.user_id}`, {
        city: this.modal_config.value,
      });
    } else if (this.modal_config.type === 4) {
      if (!this.modal_config.value) {
        this.modal_config_validator_map.wechat_id.status = 'error';
        this.modal_config_validator_map.wechat_id.help = '请填写微信号';
        return;
      } else {
        this.modal_config_validator_map.wechat_id.status = '';
        this.modal_config_validator_map.wechat_id.help = '';
      }
      this.user_info.wechat_list = [this.modal_config.value];
      this.remark = `修改微信号为【${this.modal_config.value}】`;
      await this.addRemark();
      res = await this.$axios.put(`${API.edit_wechat}${this.user_id}`, {
        wechat_list: this.user_info.wechat_list,
      });
    } else {
      if (!this.modal_config.value) {
        this.modal_config_validator_map.mobile.status = 'error';
        this.modal_config_validator_map.mobile.help = '请填写手机号';
        return;
      } else if (!this.checkPhone(this.modal_config.value)) {
        this.modal_config_validator_map.mobile.status = 'error';
        this.modal_config_validator_map.mobile.help = '手机号格式错误';
        return;
      } else {
        this.modal_config_validator_map.mobile.status = '';
        this.modal_config_validator_map.mobile.help = '';
      }
      this.remark = `修改关联手机号【${this.modal_config.value}】`;
      await this.addRemark();
      res = await this.$axios.put(`${API.add_mobile}${this.user_id}`, {
        mobile_relevance: [this.modal_config.value],
      });
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    if (this.modal_config.type === 2 || this.modal_config.type === 4) {
      this.$message.success('添加成功');
    } else {
      this.$message.success('修改成功');
    }
    this.closeModifyUserInfoModal();
    await this.getUserDetail();
  }
  // 检测手机号
  checkPhone(phone_number: any) {
    if (/^[1][3,4,5,7,8,9][0-9]{9}$/.test(phone_number)) {
      return true;
    }
    return false;
  }

  // 新增装修信息
  @changeLoading(['is_loading'])
  async addDecorationInfo() {
    const id_arr = this.decoration_data.detail.map((item: any) => item.id);
    if (!this.validateCommit(this.add_decoration_info_form, this.add_decoration_info_modal_valiedateMap)) {
      return;
    }
    const data = this.add_decoration_info_form;
    const send_data: any = {
      user_id: this.user_id,
      area: data.area,
      type: data.type,
      province_id: data.province_id,
      city_id: data.city_id,
      province_name: this.region_list.filter((item: any) => item.id === data.province_id)[0].name,
      city_name: this.region_list
        .filter((item: any) => item.id === data.province_id)[0]
        .children.filter((item2: any) => item2.id === data.city_id)[0].name,
      address: data.address,
    };
    let city_name: any;
    switch (send_data.city_id) {
      case '1101':
        city_name = '北京市';
        break;
      case '5001':
        city_name = '重庆市重庆城区';
        break;
      case '5002':
        city_name = '重庆市重庆郊县';
        break;
      case '3101':
        city_name = '上海市';
        break;
      case '1201':
        city_name = '天津市';
        break;
      default:
        if (!send_data.province_id) {
          city_name = '';
        } else {
          city_name = send_data.province_name + '省' + send_data.city_name + '市';
        }
        break;
    }
    let res;
    if (this.is_edit_decoration) {
      res = await this.$axios.put(`${API.add_decoration_info}/${this.add_decoration_info_form.id}`, send_data);
      const picture_form = storage.getItem('picture_form');
      const id = picture_form.id;
      this.remark = `装修信息【${id}】`;
      delete picture_form.id;
      const prop_arr = Object.keys(picture_form);
      const diff_arr: any = [];
      const field_map: any = {
        province_id: '装修区域',
        city_id: '装修区域',
        address: '小区地址',
        type: '房型',
        area: '面积',
      };
      prop_arr.forEach((item: any) => {
        if (send_data[item] !== picture_form[item]) {
          diff_arr.push(item);
        }
      });
      // diff_arr = diff_arr.filter((item: any) => item !== 'city_id');
      let is_repeat = false;
      diff_arr.forEach((item: any) => {
        const field = field_map[item];
        let old_value;
        let new_value;
        // if (item === 'province_id' || item === 'city_id') {
        if (item === 'province_id' || item === 'city_id') {
          if (!is_repeat) {
            let picture_city_name: any;
            switch (picture_form.city_id + '') {
              case '1101':
                picture_city_name = '北京市';
                break;
              case '5001':
                picture_city_name = '重庆市重庆城区';
                break;
              case '5002':
                picture_city_name = '重庆市重庆郊县';
                break;
              case '3101':
                picture_city_name = '上海市';
                break;
              case '1201':
                picture_city_name = '天津市';
                break;
              default:
                picture_city_name = data.province_name + '省' + data.city_name + '市';
                break;
            }
            old_value = picture_city_name;
            new_value = city_name;
          }
          is_repeat = true;
        } else if (item === 'address') {
          old_value = picture_form[item];
          new_value = send_data[item];
        } else if (item === 'type') {
          old_value = this.houstTypeMap[picture_form[item]] ? this.houstTypeMap[picture_form[item]].name : '';
          new_value = this.houstTypeMap[send_data[item]] ? this.houstTypeMap[send_data[item]].name : '';
        } else if (item === 'area') {
          old_value = picture_form[item];
          new_value = send_data[item];
        }
        if (old_value && new_value) {
          this.remark += `${field}从【${old_value}】修改为【${new_value}】；`;
        }
      });
      await this.addRemark();
    } else {
      res = await this.$axios.post(API.add_decoration_info, send_data);
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    await this.getDecorationInfo();
    if (!this.is_edit_decoration) {
      this.remark = `新增装修信息：【装修区域 ${city_name}；小区地址 ${send_data.address}；房型 ${
        this.houstTypeMap[send_data.type].name
      }； 面积 ${send_data.area}】`;
      await this.addRemark();
    }
    this.$message.success(this.is_edit_decoration ? '编辑装修信息成功' : '新增装修信息成功');
    this.closeAddDecorationModal();
  }

  // 点击装修信息删除按钮
  @changeLoading(['is_loading'])
  async deleteModal(item: any) {
    let city_name: any;
    switch (item.city_id) {
      case 1101:
        city_name = '北京市';
        break;
      case 5001:
        city_name = '重庆市重庆城区';
        break;
      case 5002:
        city_name = '重庆市重庆郊县';
        break;
      case 3101:
        city_name = '上海市';
        break;
      case 1201:
        city_name = '天津市';
        break;
      default:
        city_name = item.province_name + '省' + item.city_name + '市';
        break;
    }
    this.$confirm({
      title: '确认删除？',
      icon: 'null',
      onOk: async () => {
        const res = await this.$axios.delete(`${API.delete_decoration_info}${item.id}`);
        if (res.data.status !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        this.$message.success('删除成功');
        await this.getDecorationInfo();
        this.remark = `删除装修信息【装修区域 ${city_name}；小区地址${item.address}；房型 ${
          this.houstTypeMap[item.type].name
        }；面积 ${item.area}；】`;
        await this.addRemark();
      },
    });
  }

  // 获取装修信息
  @changeLoading(['is_loading'])
  async getDecorationInfo(
    query_params: any = {
      current: 1,
      user_id: this.user_id,
    }
  ) {
    const url = getUrl(API.decoration_info, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.decoration_data = initDecorationInfoData(res.data.data);
    this.decoration_data.detail.forEach((item: any, index: number) => {
      item.sort = (this.decoration_data.current - 1) * 10 + (index + 1);
    });
  }

  // 获取报名列表
  @changeLoading(['is_loading'])
  async getApplyList(
    query_params: any = {
      user_id: this.user_id,
      limit: 5,
      current: 1,
    }
  ) {
    const url = getUrl(API.apply_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.apply_data = initDecorationInfoData(res.data.data);
  }

  // 切换报名列表分页
  @changeLoading(['is_loading'])
  async handleApplyChange(data: any) {
    await this.getApplyList({
      user_id: this.user_id,
      current: data.current,
      limit: 5,
    });
  }

  // 获取地区列表
  @changeLoading(['is_loading'])
  async getRegionList() {
    const res = await this.$axios.get(API.region_list);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.region_list = res.data;
    this.region_list.forEach((item: any) => {
      if (item.id === '33') {
        this.city_list = item.children;
      }
    });
  }

  // 获取用户详情
  @changeLoading(['is_loading'])
  async getUserDetail() {
    const res = await this.$axios.get(`${API.get_user_detail}${this.user_id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.user_info = initUserInfo(res.data.data);
    this.status_change_value.status = this.user_info.status;
    if (this.user_info.status === 3) {
      this.status_change_value.undetermind_cause = this.user_info.sub_status;
      this.status_change_value.visit_time = moment(this.user_info.plan_visit_time * 1000);
    } else {
      this.status_change_value.undetermind_cause = undefined;
    }
    if (this.user_info.status === 4) {
      this.status_change_value.detail = this.user_info.sub_status;
    } else {
      this.status_change_value.detail = undefined;
    }
    if (this.user_info.status === 7) {
      this.status_change_value.invalid = this.user_info.sub_status;
    } else {
      this.status_change_value.invalid = undefined;
    }
  }

  @changeLoading(['is_loading'])
  async created() {
    this.user_id = +this.$route.query.id;
    await this.getUserDetail(); // 用户信息
    await this.getDecorationInfo(); // 装修信息
    await this.getList(); // 获取管家列表
    await this.getApplyList(); // 获取报名列表
    await this.remarkData(); // 获取跟进记录
    await this.getSignData(); // 获取签约列表
    await this.getRefundData({
      user_id: this.user_id,
      current: 1,
    }); // 获取退单列表
    await this.getDepositData({
      user_id: this.user_id,
      current: 1,
      status: '0',
    });
    await this.getAllDepositData(); // 获取全部下订列表
    await this.getContractData(); // 获取所有合同
    await this.getApplyCount(); // 获取报名次数
    await this.getRegionList(); // 获取地区列表
  }
}
